export const REGISTRATION_TYPE_SOLSELL = 'solsell.jp'

export const USER_TYPE_ADMIN = 'admin'
export const USER_TYPE_CORPORATION = 'corporation'
export const USER_TYPE_INDIVIDUAL = 'individual'
